import { getArgs } from "../utils";
import api from "./api";

const route = "/progresos";

export default {
  getAvanceFinanciero: (idProyecto, fecha) =>
    api.get(`${route}/${idProyecto}/financiero`, {
      params: fecha ? { fecha } : undefined,
    }),
  getProyeccion: (idProyecto, fecha) =>
    api.get(`${route}/${idProyecto}/proyeccion`, {
      params: fecha ? { fecha } : undefined,
    }),
  getProgreso: (idProyecto, filters) => api.get(`${route}/${idProyecto}?${getArgs(filters)}`),
};
